// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27%2364748b%27 height=%2720%27 viewBox=%270 0 20 20%27 width=%2720%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M5.516 7.548a.625.625 0 0 1 .884 0L10 11.149l3.6-3.6a.625.625 0 1 1 .884.884l-4.042 4.042a.625.625 0 0 1-.884 0L5.516 8.432a.625.625 0 0 1 0-.884z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TenantInvite_hierarchySection__Ok0pO { border: 1px solid #e0e0e0; border-radius: 10px; padding: 16px; margin: 16px 0; background: #fafbfc; }
.TenantInvite_hierarchyHeader__j5lzG { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; flex-wrap: wrap; margin-bottom: 12px; }
.TenantInvite_hierarchyTitle__gSNf8 { margin: 0 0 4px; font-size: 16px; }
.TenantInvite_hierarchySubtitle__66LQx { margin: 0; font-size: 12px; color: #6b7280; }
.TenantInvite_hierarchyControls__QTHMr { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.TenantInvite_hierarchySearch__INI2N { padding: 6px 10px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 13px; min-width: 200px; }
.TenantInvite_hierarchyBtn__bjKGF { padding: 6px 10px; border: 1px solid #d1d5db; background: #fff; border-radius: 6px; font-size: 12px; cursor: pointer; }
.TenantInvite_hierarchyBtn__bjKGF:hover:not(:disabled) { background: #f3f4f6; }
.TenantInvite_hierarchyBtn__bjKGF:disabled { opacity: 0.5; cursor: not-allowed; }

.TenantInvite_hierarchyTree__nnNoc { font-size: 13px; }
.TenantInvite_hierarchyParent__fAfJ3 { display: flex; align-items: center; gap: 8px; padding: 10px 12px; background: #eef2ff; border-radius: 8px; font-weight: 600; margin-bottom: 8px; }
.TenantInvite_hierarchyParentIcon__lDzIq { font-size: 16px; }
.TenantInvite_hierarchyParentName__5U2CB { flex: 1 1; }
.TenantInvite_hierarchyBadge__sUjmh { font-size: 11px; font-weight: 500; background: #dbeafe; color: #1e40af; padding: 2px 8px; border-radius: 999px; }

.TenantInvite_hierarchyDepartment__rF720 { margin-left: 12px; border-left: 2px dashed #e5e7eb; padding-left: 12px; margin-bottom: 6px; }
.TenantInvite_hierarchyDepartmentHeader__FF5QL { display: flex; align-items: center; gap: 8px; width: 100%; background: none; border: none; padding: 8px 4px; cursor: pointer; text-align: left; font-size: 13px; border-radius: 6px; }
.TenantInvite_hierarchyDepartmentHeader__FF5QL:hover:not(:disabled) { background: #f3f4f6; }
.TenantInvite_hierarchyCaret__K7QuZ { width: 14px; color: #6b7280; }
.TenantInvite_hierarchyDepartmentIcon__yUV5w { font-size: 15px; }
.TenantInvite_hierarchyDepartmentName__ODrYa { flex: 1 1; font-weight: 600; }

.TenantInvite_hierarchyUserList__yMfop { list-style: none; padding: 0; margin: 4px 0 4px 24px; border-left: 1px solid #e5e7eb; padding-left: 12px; }
.TenantInvite_hierarchyUserItem__UxJR3 { display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 6px; margin-bottom: 4px; background: #fff; border: 1px solid #eef0f3; }
.TenantInvite_hierarchyUserActive__yzMdJ { border-color: #3b82f6; background: #eff6ff; }
.TenantInvite_hierarchyUserIcon__j9p03 { font-size: 14px; }
.TenantInvite_hierarchyUserInfo__KkeXV { display: flex; flex-direction: column; flex: 1 1; min-width: 0; }
.TenantInvite_hierarchyUserName__K3KSU { font-weight: 500; }
.TenantInvite_hierarchyUserEmail__xTmAR { font-size: 11px; color: #6b7280; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.TenantInvite_hierarchyRoles__xWYP2 { font-size: 11px; color: #7c3aed; background: #f5f3ff; padding: 2px 8px; border-radius: 999px; }
.TenantInvite_hierarchySelectBtn__QHEZi { padding: 4px 10px; font-size: 11px; border: 1px solid #3b82f6; background: #fff; color: #2563eb; border-radius: 6px; cursor: pointer; }
.TenantInvite_hierarchySelectBtn__QHEZi:hover:not(:disabled) { background: #eff6ff; }
.TenantInvite_hierarchySelectBtn__QHEZi:disabled { opacity: 0.5; cursor: not-allowed; }

/* ========== MAIN CONTAINER ========== */
.TenantInvite_container__AgJIy {
  width: 100%;
  padding: 2rem;
  height: 100%;
  min-height: 100vh;
}

/* ========== TITLE ========== */
.TenantInvite_title__cIsDT {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: var(--dark-color);
  text-align: center;
  letter-spacing: 0.5px;
  padding-bottom: 24px;
  border-bottom: 2px solid #e9ecef;
  letter-spacing: -0.5px;
  position: relative;
}

/* ========== HEADER SECTION ========== */
.TenantInvite_headerSection__zSukl {
  margin-bottom: 28px;
  padding: 20px 0px;
}

.TenantInvite_inviteSelectorsWrap__-Ipht {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 20px;
  border-radius: 12px;
  padding: 24px;
  transition: all 0.3s ease;
  width: 100%;
  border: 1px solid #e9ecef;
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: rgb(233, 236, 239);
  box-shadow: var(--shadow-md);
  background: var(--white-color);
}

.TenantInvite_selectSelectorsWrap__EpKTE {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

/* ========== MODE SELECTOR ========== */
.TenantInvite_modeSelector__yEKbA {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.TenantInvite_modeSelector__yEKbA label {
  font-weight: 500;
  font-size: 0.95rem;
  color: #1e293b;
}

.TenantInvite_modeDropdown__YdVWY {
  appearance: none;
  width: 100%;
  max-width: 300px;
  padding: 0.8rem 2.5rem 0.8rem 1rem;
  font-size: 0.95rem;
  border-radius: 10px;
  border: 2px solid #e2e8f0;
  background-color: #ffffff;
  color: #0f172a;
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.8rem center;
  background-size: 1.2rem;
  transition: all 0.3s ease;
  font-weight: 500;
}

.TenantInvite_modeDropdown__YdVWY:hover:not(:disabled) {
  border-color: #94a3b8;
}

.TenantInvite_modeDropdown__YdVWY:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
}

.TenantInvite_modeDropdown__YdVWY:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f1f5f9;
}

/* ========== WRAPPER ========== */
.TenantInvite_wrapper__thZPy {
  display: flex;
  align-items: center;
  gap: 16px;
  /* flex-wrap: wrap; */
  flex: 1 1;
}

/* ========== INPUT WRAPPERS ========== */
.TenantInvite_emailInputWrap__rNm9q,
.TenantInvite_nameInputWrap__Z60jS {
  display: flex;
  align-items: center;
  gap: 10px;
}

.TenantInvite_emailInputWrap__rNm9q label,
.TenantInvite_nameInputWrap__Z60jS label {
  font-weight: 500;
  font-size: 0.95rem;
  color: #1e293b;
  white-space: nowrap;
}

.TenantInvite_emailInput__pz0Rv {
  height: 48px;
  outline: none;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.95rem;
  padding: 10px 14px;
  width: 100%;
  max-width: 350px;
  transition: all 0.3s ease;
  background: #ffffff;
  color: #0f172a;
}

.TenantInvite_emailInput__pz0Rv:hover:not(:disabled) {
  border-color: #94a3b8;
}

.TenantInvite_emailInput__pz0Rv:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
  outline: none;
}

.TenantInvite_emailInput__pz0Rv:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f1f5f9;
}

/* ========== USER TABS ========== */
.TenantInvite_userTabs__K-184 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
}

.TenantInvite_userTab__bP7lH {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 8px 16px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #1e293b;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.TenantInvite_userTab__bP7lH:hover {
  border-color: #94a3b8;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.TenantInvite_removeBtn__FPK3c {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  font-weight: 300;
}

.TenantInvite_removeBtn__FPK3c:hover:not(:disabled) {
  background-color: #fee2e2;
  color: #ef4444;
}

.TenantInvite_removeBtn__FPK3c:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ========== ROLES SECTION ========== */
.TenantInvite_rolesSection__OY6Fo {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 24px;
  margin: 10px 0;
  width: 100%;
  transition: all 0.3s ease;
  background-color: white;
}

.TenantInvite_rolesHeader__rVISl {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.TenantInvite_rolesHeader__rVISl h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
}

.TenantInvite_rolesGrid__uQo4O {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
}

.TenantInvite_roleCheckbox__blIOe {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

/* .roleCheckbox:hover {
  background-color: #f1f5f9;
} */

.TenantInvite_roleCheckbox__blIOe input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--saveBtn);
  border-radius: 4px;
  color: var(--white-color);
}

.TenantInvite_roleCheckbox__blIOe input[type="checkbox"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.TenantInvite_roleCheckbox__blIOe label {
  font-size: 0.95rem;
  color: #1e293b;
  cursor: pointer;
  font-weight: 500;
}

.TenantInvite_noRolesHint__2PNVu {
  color: #94a3b8;
  font-size: 0.9rem;
  font-style: italic;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 6px;
}

.TenantInvite_createPermissions__uFx4B {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 24px;
  margin: 10px 0;
  width: 100%;
  transition: all 0.3s ease;
}

.TenantInvite_createPermissions__uFx4B:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.TenantInvite_createPermissionsHeader__b3t5U {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.TenantInvite_createPermissionsHeader__b3t5U h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
}

.TenantInvite_createPermissionsGrid__5ZLpV {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.TenantInvite_createPermissionItem__GzkCU {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.TenantInvite_createPermissionItem__GzkCU:hover {
  background-color: #f1f5f9;
}

.TenantInvite_createPermissionItem__GzkCU input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #3b82f6;
  border-radius: 4px;
}

.TenantInvite_createPermissionItem__GzkCU input[type="checkbox"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.TenantInvite_createPermissionItem__GzkCU label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  cursor: pointer;
  font-size: 0.95rem;
  color: #1e293b;
}

/* ========== INFO ICON ========== */
.TenantInvite_infoIcon__qE-96 {
  color: #94a3b8;
  cursor: help;
  font-size: 16px;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #f1f5f9;
  transition: all 0.3s ease;
  font-weight: 600;
}

.TenantInvite_infoIcon__qE-96:hover {
  background: #e2e8f0;
  color: #475569;
}

.TenantInvite_permissionInfo__GmT94 {
  color: #94a3b8;
  cursor: help;
  font-size: 14px;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}

/* ========== TOOLTIP ========== */
.TenantInvite_tooltip__gLlp\\+ {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  background: #1e293b;
  color: #f8fafc;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 0.8rem;
  width: 220px;
  z-index: 1000;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  line-height: 1.5;
  font-weight: 400;
}

.TenantInvite_tooltip__gLlp\\+::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: #1e293b transparent transparent transparent;
}

/* ========== MULTI-TENANT NOTICE ========== */
.TenantInvite_multiTenantNotice__FChMF {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border: 1px solid #fcd34d;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.08);
}

.TenantInvite_noticeIcon__RSfKz {
  font-size: 24px;
  flex-shrink: 0;
}

.TenantInvite_multiTenantNotice__FChMF strong {
  font-weight: 600;
  color: #92400e;
  margin-right: 4px;
}

/* ========== ERROR MESSAGE ========== */
.TenantInvite_errorMessage__4Md7K {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fca5a5;
  border-radius: 12px;
  padding: 14px 18px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  color: #991b1b;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.06);
}

.TenantInvite_errorIcon__M\\+WDG {
  font-size: 20px;
  margin-right: 12px;
  flex-shrink: 0;
}

.TenantInvite_closeErrorBtn__gfFG2 {
  margin-left: auto;
  background: none;
  border: none;
  color: #991b1b;
  font-size: 24px;
  cursor: pointer;
  padding: 0 6px;
  transition: all 0.2s ease;
  opacity: 0.7;
}

.TenantInvite_closeErrorBtn__gfFG2:hover {
  opacity: 1;
  transform: scale(1.1);
}

/* ========== PERMISSION NOTE ========== */
.TenantInvite_permissionNote__qw8z\\+ {
  border: 2px solid #bbd8ff;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
  background: #d9e9ff;
  transition: all 0.2s ease;
}

.TenantInvite_authServerTitle__1SwFt {
  color: #1a1614;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 20px;
}

.TenantInvite_permissionNote__qw8z\\+ strong {
  font-weight: 600;
  color: var(--primary);
}

.TenantInvite_availablePermission__Pr\\+n1 {
  background: var(--gradient-success);
  color: var(--heading);
  padding: 2px 10px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.8rem;
  margin: 0 4px;
}

/* ========== SUBMIT BUTTON ========== */
.TenantInvite_submitWrapper__87mgq {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.TenantInvite_submitBtn__9v9GH {
  background: var(--gradient-primary);
  color: var(--white-color);
  font-size: 1rem;
  font-weight: 600;
  padding: 14px 32px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 200px;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  position: relative;
  overflow: hidden;
}

.TenantInvite_submitBtn__9v9GH::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}

.TenantInvite_submitBtn__9v9GH:hover:not(:disabled)::before {
  left: 100%;
}

.TenantInvite_submitBtn__9v9GH:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}

.TenantInvite_submitBtn__9v9GH:active:not(:disabled) {
  transform: translateY(0);
}

.TenantInvite_submitBtn__9v9GH:disabled {
  background: var(--cancelBtn);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
  color: var(--heading);
}

/* ========== TABLE ========== */
.TenantInvite_tableWrapper__-GxpV {
  border-radius: 12px;
  overflow-x: auto;
  width: 100%;
  color: #1a1a1a;
  -webkit-overflow-scrolling: touch;
  background: var(--white-color);
  padding: 1.5rem 0;
  margin-top: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  border-radius: 12px;
}

.TenantInvite_table__TZSnm {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  min-width: 600px;
}

.TenantInvite_table__TZSnm th,
.TenantInvite_table__TZSnm td {
  padding: 14px 16px;
  text-align: left;
  font-size: 0.95rem;
  font-weight: 400;
  height: 60px;
}

.TenantInvite_table__TZSnm th {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  color: #1e293b;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 10;
}

.TenantInvite_table__TZSnm td {
  border-bottom: 1px solid #f1f5f9;
  background-color: #ffffff;
  transition: all 0.2s ease;
}

.TenantInvite_table__TZSnm tbody tr {
  transition: all 0.2s ease;
}

.TenantInvite_table__TZSnm tbody tr:hover td {
  background-color: #f8fafc;
}

.TenantInvite_table__TZSnm tbody tr:last-child td {
  border-bottom: none;
}

.TenantInvite_table__TZSnm input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #3b82f6;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.TenantInvite_table__TZSnm input[type="checkbox"]:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.TenantInvite_th__tBfDk {
  position: relative;
}

.TenantInvite_td__cGZBw {
  position: relative;
}

.TenantInvite_checkboxWrapper__FON6O {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ========== LOADING STATES ========== */
.TenantInvite_loadingText__5hzIe {
  font-size: 1rem;
  color: #64748b;
  text-align: center;
  padding: 40px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.TenantInvite_loadingText__5hzIe::before {
  content: "";
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #3b82f6;
  border-radius: 50%;
  animation: TenantInvite_spin__ZwKtJ 0.8s linear infinite;
}

@keyframes TenantInvite_spin__ZwKtJ {
  to {
    transform: rotate(360deg);
  }
}

.TenantInvite_noDataText__ofCoE {
  font-size: 1rem;
  color: #94a3b8;
  text-align: center;
  padding: 40px 20px;
  font-style: italic;
}

/* ========== ADMIN ONLY MESSAGE ========== */
.TenantInvite_adminOnlyMessage__fs73U {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 80px 40px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
  max-width: 600px;
  margin: 60px auto;
  min-height: 400px;
}

.TenantInvite_adminOnlyIcon__ACJqt {
  font-size: 72px;
  margin-bottom: 24px;
  color: #94a3b8;
  animation: TenantInvite_float__RTVOd 3s ease-in-out infinite;
}

@keyframes TenantInvite_float__RTVOd {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.TenantInvite_adminOnlyTitle__uJ4qK {
  color: #1e293b;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.3;
}

.TenantInvite_adminOnlyText__XP\\+he {
  color: #64748b;
  font-size: 16px;
  line-height: 1.7;
  max-width: 500px;
  margin: 0 auto;
}

/* ========== MODAL ========== */
.TenantInvite_modalOverlay__w6\\+im {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: TenantInvite_fadeIn__zROY0 0.3s ease;
}

@keyframes TenantInvite_fadeIn__zROY0 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.TenantInvite_modal__wC7Pc {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: TenantInvite_modalSlideIn__RRQG3 0.3s ease-out;
}

@keyframes TenantInvite_modalSlideIn__RRQG3 {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.TenantInvite_modalHeader__f25i6 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
}

.TenantInvite_modalHeader__f25i6 h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.TenantInvite_closeButton__OgzFN {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #94a3b8;
  padding: 4px 8px;
  line-height: 1;
  transition: all 0.2s ease;
  border-radius: 6px;
}

.TenantInvite_closeButton__OgzFN:hover {
  background: #f1f5f9;
  color: #475569;
}

.TenantInvite_modalContent__M-P1h {
  padding: 32px 24px;
  text-align: center;
}

.TenantInvite_modalIcon__AykcE {
  font-size: 56px;
  color: #3b82f6;
  margin-bottom: 16px;
}

.TenantInvite_modalContent__M-P1h p {
  margin: 0 0 16px 0;
  font-size: 1.1rem;
  color: #475569;
  line-height: 1.6;
}

.TenantInvite_modalContent__M-P1h .TenantInvite_note__m94kL {
  font-size: 0.9rem;
  color: #64748b;
  margin-top: 16px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
  border-left: 4px solid #3b82f6;
  text-align: left;
}

.TenantInvite_modalFooter__YanCd {
  padding: 20px 24px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.TenantInvite_modalButton__1wdTi {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.TenantInvite_modalButton__1wdTi:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

/* ========== UPCOMING FEATURES ========== */
.TenantInvite_upcomingHeader__4Aec9 {
  position: relative;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%) !important;
}

.TenantInvite_comingSoonBadge__TQuuU {
  position: absolute;
  top: 4px;
  right: 6px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  font-size: 0.65rem;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.TenantInvite_upcomingCell__xdoQZ {
  position: relative;
  background: #fffbeb !important;
  cursor: not-allowed;
}

.TenantInvite_upcomingCell__xdoQZ:hover {
  background: #fef3c7 !important;
}

.TenantInvite_disabledCheckbox__4Qf9R {
  cursor: not-allowed !important;
  opacity: 0.4;
  position: relative;
  z-index: 1;
}

.TenantInvite_upcomingOverlay__sCe0z {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.TenantInvite_upcomingText__\\+IQuF {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 600;
  opacity: 0.9;
  letter-spacing: 0.3px;
}

/* ========== DISABLED STATES ========== */
input:disabled,
select:disabled,
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.TenantInvite_authServerDescription__RrtZc {
  font-size: 0.875rem;
  color: #5f6368;
  line-height: 1.5;
}

.TenantInvite_authServerDescription__RrtZc code {
  background-color: #f1f3f4;
  padding: 2px 6px;
  border-radius: 6px;
  font-family: "Courier New", monospace;
  font-size: 0.813rem;
  color: #ff32cc;
}
/* ========== RESPONSIVE DESIGN ========== */
@media (min-width: 768px) {
  .TenantInvite_createPermissionsGrid__5ZLpV {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  .TenantInvite_rolesGrid__uQo4O {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
}

@media (max-width: 767px) {
  .TenantInvite_container__AgJIy {
    padding: 1rem;
  }

  .TenantInvite_title__cIsDT {
    font-size: 1.5rem;
  }

  .TenantInvite_headerSection__zSukl {
    padding: 0px;
  }

  .TenantInvite_modeSelector__yEKbA {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }

  .TenantInvite_modeDropdown__YdVWY {
    max-width: 100%;
    width: 100%;
  }

  .TenantInvite_selectSelectorsWrap__EpKTE {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .TenantInvite_wrapper__thZPy {
    flex-direction: column;
    width: 100%;
    gap: 12px;
  }

  .TenantInvite_emailInputWrap__rNm9q,
  .TenantInvite_nameInputWrap__Z60jS {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 6px;
  }

  .TenantInvite_emailInput__pz0Rv {
    max-width: 100%;
    width: 100%;
  }

  .TenantInvite_createPermissions__uFx4B {
    padding: 16px;
  }

  .TenantInvite_createPermissionsGrid__5ZLpV {
    grid-template-columns: 1fr;
  }

  .TenantInvite_permissionNote__qw8z\\+ {
    flex-direction: column;
    gap: 10px;
    padding: 16px;
  }

  .TenantInvite_userTabs__K-184 {
    max-width: 100%;
    overflow-x: auto;
    flex-wrap: nowrap;
    padding-bottom: 5px;
  }

  .TenantInvite_userTab__bP7lH {
    white-space: nowrap;
  }

  .TenantInvite_submitBtn__9v9GH {
    width: 100%;
    min-width: auto;
  }

  .TenantInvite_submitWrapper__87mgq {
    justify-content: stretch;
  }

  .TenantInvite_tableWrapper__-GxpV {
    padding: 1rem 0.5rem;
    margin: 15px -1rem;
    width: calc(100% + 2rem);
    border-radius: 0;
  }

  .TenantInvite_table__TZSnm {
    min-width: 500px;
  }

  .TenantInvite_table__TZSnm th,
  .TenantInvite_table__TZSnm td {
    padding: 10px 12px;
    font-size: 0.875rem;
    height: 50px;
  }

  .TenantInvite_inviteSelectorsWrap__-Ipht {
    align-items: flex-start;
  }

  .TenantInvite_rolesGrid__uQo4O {
    grid-template-columns: 1fr 1fr;
  }

  .TenantInvite_multiTenantNotice__FChMF {
    flex-direction: column;
    text-align: center;
  }

  .TenantInvite_errorMessage__4Md7K {
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
  }

  .TenantInvite_adminOnlyMessage__fs73U {
    padding: 40px 20px;
    margin: 30px 16px;
    min-height: 300px;
  }

  .TenantInvite_adminOnlyTitle__uJ4qK {
    font-size: 24px;
  }

  .TenantInvite_modal__wC7Pc {
    width: 95%;
  }
}

@media (max-width: 480px) {
  .TenantInvite_container__AgJIy {
    padding: 0rem;
  }

  .TenantInvite_title__cIsDT {
    font-size: 1.25rem;
  }

  .TenantInvite_emailInput__pz0Rv,
  .TenantInvite_modeDropdown__YdVWY {
    font-size: 16px; /* Prevent zoom on iOS */
  }

  .TenantInvite_createPermissionsHeader__b3t5U {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .TenantInvite_createPermissionsHeader__b3t5U h3 {
    font-size: 0.95rem;
  }

  .TenantInvite_permissionNote__qw8z\\+ {
    font-size: 0.875rem;
  }

  .TenantInvite_availablePermission__Pr\\+n1 {
    padding: 2px 8px;
    font-size: 0.75rem;
  }

  .TenantInvite_table__TZSnm {
    min-width: 400px;
  }

  .TenantInvite_table__TZSnm th,
  .TenantInvite_table__TZSnm td {
    padding: 8px 10px;
    font-size: 0.813rem;
    height: 44px;
  }

  .TenantInvite_table__TZSnm input[type="checkbox"] {
    width: 16px;
    height: 16px;
  }

  .TenantInvite_rolesGrid__uQo4O {
    grid-template-columns: 1fr;
  }

  .TenantInvite_submitBtn__9v9GH {
    font-size: 0.95rem;
    padding: 12px 20px;
  }

  .TenantInvite_roleCheckbox__blIOe {
    padding: 4px 8px;
  }

  .TenantInvite_createPermissionItem__GzkCU {
    padding: 6px 8px;
  }
}

/* ========== PRINT STYLES ========== */
@media print {
  .TenantInvite_container__AgJIy {
    box-shadow: none;
    padding: 0;
    background: white;
    min-height: auto;
  }

  .TenantInvite_submitBtn__9v9GH,
  .TenantInvite_removeBtn__FPK3c,
  .TenantInvite_closeErrorBtn__gfFG2 {
    display: none !important;
  }

  .TenantInvite_table__TZSnm {
    min-width: auto;
  }

  .TenantInvite_headerSection__zSukl,
  .TenantInvite_rolesSection__OY6Fo,
  .TenantInvite_createPermissions__uFx4B {
    box-shadow: none;
    border: 1px solid #ddd;
  }

  .TenantInvite_tableWrapper__-GxpV {
    box-shadow: none;
    border: 1px solid #ddd;
  }
}

/* ========== ACCESSIBILITY ========== */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

@media (prefers-contrast: high) {
  .TenantInvite_errorMessage__4Md7K {
    border: 2px solid #c00;
  }

  .TenantInvite_multiTenantNotice__FChMF {
    border: 2px solid #856404;
  }

  .TenantInvite_table__TZSnm th {
    border-bottom: 3px solid #000;
  }

  .TenantInvite_submitBtn__9v9GH {
    border: 2px solid #1d4ed8;
  }
}
/* Minimalist Permission Note */
.TenantInvite_permissionNoteMinimal__eW24k {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 32px;
  transition: all 0.2s ease;
  position: relative;
}

.TenantInvite_permissionNoteMinimal__eW24k:hover {
  border-color: #94a3b8;
  background: #f1f5f9;
}

.TenantInvite_permissionNoteMinimal__eW24k .TenantInvite_noteIcon__BnCx7 {
  color: #3b82f6;
  font-size: 20px;
}

.TenantInvite_permissionNoteMinimal__eW24k .TenantInvite_authServerDescription__RrtZc {
  color: #475569;
  font-size: 0.9rem;
  line-height: 1.6;
}

.TenantInvite_permissionNoteMinimal__eW24k .TenantInvite_availablePermission__Pr\\+n1 {
  background: #3b82f6;
  color: white;
  padding: 1px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  margin: 0 3px;
}

.TenantInvite_permissionNoteMinimal__eW24k .TenantInvite_authServerDescription__RrtZc code {
  background: #e2e8f0;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 0.8rem;
  color: #7c3aed;
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/InviteSupportUser/TenantInvite.module.css"],"names":[],"mappings":"AAAA,wCAAoB,yBAAyB,EAAE,mBAAmB,EAAE,aAAa,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACxH,uCAAmB,aAAa,EAAE,8BAA8B,EAAE,uBAAuB,EAAE,SAAS,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAC5I,sCAAkB,eAAe,EAAE,eAAe,EAAE;AACpD,yCAAqB,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE;AACjE,yCAAqB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACpF,uCAAmB,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACxH,oCAAgB,iBAAiB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE;AACtI,yDAAqC,mBAAmB,EAAE;AAC1D,6CAAyB,YAAY,EAAE,mBAAmB,EAAE;;AAE5D,qCAAiB,eAAe,EAAE;AAClC,uCAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACpK,2CAAuB,eAAe,EAAE;AACxC,2CAAuB,SAAO,EAAE;AAChC,sCAAkB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;;AAElI,2CAAuB,iBAAiB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AACnH,iDAA6B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,WAAW,EAAE,gBAAgB,EAAE,YAAY,EAAE,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAClN,sEAAkD,mBAAmB,EAAE;AACvE,sCAAkB,WAAW,EAAE,cAAc,EAAE;AAC/C,+CAA2B,eAAe,EAAE;AAC5C,+CAA2B,SAAO,EAAE,gBAAgB,EAAE;;AAEtD,yCAAqB,gBAAgB,EAAE,UAAU,EAAE,sBAAsB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE;AAC/H,yCAAqB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AAC5K,2CAAuB,qBAAqB,EAAE,mBAAmB,EAAE;AACnE,yCAAqB,eAAe,EAAE;AACtC,yCAAqB,aAAa,EAAE,sBAAsB,EAAE,SAAO,EAAE,YAAY,EAAE;AACnF,yCAAqB,gBAAgB,EAAE;AACvC,0CAAsB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACvH,sCAAkB,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAChH,0CAAsB,iBAAiB,EAAE,eAAe,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC5J,+DAA2C,mBAAmB,EAAE;AAChE,mDAA+B,YAAY,EAAE,mBAAmB,EAAE;;AAElE,yCAAyC;AACzC;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,qCAAqC;EACrC,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;EACX,8BAA8B;AAChC;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yDAAyT;EACzT,4BAA4B;EAC5B,wCAAwC;EACxC,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,SAAO;AACT;;AAEA,yCAAyC;AACzC;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA,8CAA8C;AAC9C;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,iCAAiC;EACjC,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,wDAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,4DAAwC;AAC1C;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+CAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,yDAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;AAChB;AACA,4CAA4C;AAC5C;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,SAAS;EACX;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe,EAAE,wBAAwB;EAC3C;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;AACF;AACA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".hierarchySection { border: 1px solid #e0e0e0; border-radius: 10px; padding: 16px; margin: 16px 0; background: #fafbfc; }\n.hierarchyHeader { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; flex-wrap: wrap; margin-bottom: 12px; }\n.hierarchyTitle { margin: 0 0 4px; font-size: 16px; }\n.hierarchySubtitle { margin: 0; font-size: 12px; color: #6b7280; }\n.hierarchyControls { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }\n.hierarchySearch { padding: 6px 10px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 13px; min-width: 200px; }\n.hierarchyBtn { padding: 6px 10px; border: 1px solid #d1d5db; background: #fff; border-radius: 6px; font-size: 12px; cursor: pointer; }\n.hierarchyBtn:hover:not(:disabled) { background: #f3f4f6; }\n.hierarchyBtn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.hierarchyTree { font-size: 13px; }\n.hierarchyParent { display: flex; align-items: center; gap: 8px; padding: 10px 12px; background: #eef2ff; border-radius: 8px; font-weight: 600; margin-bottom: 8px; }\n.hierarchyParentIcon { font-size: 16px; }\n.hierarchyParentName { flex: 1; }\n.hierarchyBadge { font-size: 11px; font-weight: 500; background: #dbeafe; color: #1e40af; padding: 2px 8px; border-radius: 999px; }\n\n.hierarchyDepartment { margin-left: 12px; border-left: 2px dashed #e5e7eb; padding-left: 12px; margin-bottom: 6px; }\n.hierarchyDepartmentHeader { display: flex; align-items: center; gap: 8px; width: 100%; background: none; border: none; padding: 8px 4px; cursor: pointer; text-align: left; font-size: 13px; border-radius: 6px; }\n.hierarchyDepartmentHeader:hover:not(:disabled) { background: #f3f4f6; }\n.hierarchyCaret { width: 14px; color: #6b7280; }\n.hierarchyDepartmentIcon { font-size: 15px; }\n.hierarchyDepartmentName { flex: 1; font-weight: 600; }\n\n.hierarchyUserList { list-style: none; padding: 0; margin: 4px 0 4px 24px; border-left: 1px solid #e5e7eb; padding-left: 12px; }\n.hierarchyUserItem { display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 6px; margin-bottom: 4px; background: #fff; border: 1px solid #eef0f3; }\n.hierarchyUserActive { border-color: #3b82f6; background: #eff6ff; }\n.hierarchyUserIcon { font-size: 14px; }\n.hierarchyUserInfo { display: flex; flex-direction: column; flex: 1; min-width: 0; }\n.hierarchyUserName { font-weight: 500; }\n.hierarchyUserEmail { font-size: 11px; color: #6b7280; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.hierarchyRoles { font-size: 11px; color: #7c3aed; background: #f5f3ff; padding: 2px 8px; border-radius: 999px; }\n.hierarchySelectBtn { padding: 4px 10px; font-size: 11px; border: 1px solid #3b82f6; background: #fff; color: #2563eb; border-radius: 6px; cursor: pointer; }\n.hierarchySelectBtn:hover:not(:disabled) { background: #eff6ff; }\n.hierarchySelectBtn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ========== MAIN CONTAINER ========== */\n.container {\n  width: 100%;\n  padding: 2rem;\n  height: 100%;\n  min-height: 100vh;\n}\n\n/* ========== TITLE ========== */\n.title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  color: var(--dark-color);\n  text-align: center;\n  letter-spacing: 0.5px;\n  padding-bottom: 24px;\n  border-bottom: 2px solid #e9ecef;\n  letter-spacing: -0.5px;\n  position: relative;\n}\n\n/* ========== HEADER SECTION ========== */\n.headerSection {\n  margin-bottom: 28px;\n  padding: 20px 0px;\n}\n\n.inviteSelectorsWrap {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 20px;\n  border-radius: 12px;\n  padding: 24px;\n  transition: all 0.3s ease;\n  width: 100%;\n  border: 1px solid #e9ecef;\n  border-left-width: 1px;\n  border-left-style: solid;\n  border-left-color: rgb(233, 236, 239);\n  box-shadow: var(--shadow-md);\n  background: var(--white-color);\n}\n\n.selectSelectorsWrap {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: space-between;\n}\n\n/* ========== MODE SELECTOR ========== */\n.modeSelector {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n}\n\n.modeSelector label {\n  font-weight: 500;\n  font-size: 0.95rem;\n  color: #1e293b;\n}\n\n.modeDropdown {\n  appearance: none;\n  width: 100%;\n  max-width: 300px;\n  padding: 0.8rem 2.5rem 0.8rem 1rem;\n  font-size: 0.95rem;\n  border-radius: 10px;\n  border: 2px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #0f172a;\n  cursor: pointer;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='%2364748b' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M5.516 7.548a.625.625 0 0 1 .884 0L10 11.149l3.6-3.6a.625.625 0 1 1 .884.884l-4.042 4.042a.625.625 0 0 1-.884 0L5.516 8.432a.625.625 0 0 1 0-.884z'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 0.8rem center;\n  background-size: 1.2rem;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.modeDropdown:hover:not(:disabled) {\n  border-color: #94a3b8;\n}\n\n.modeDropdown:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);\n}\n\n.modeDropdown:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background-color: #f1f5f9;\n}\n\n/* ========== WRAPPER ========== */\n.wrapper {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  /* flex-wrap: wrap; */\n  flex: 1;\n}\n\n/* ========== INPUT WRAPPERS ========== */\n.emailInputWrap,\n.nameInputWrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.emailInputWrap label,\n.nameInputWrap label {\n  font-weight: 500;\n  font-size: 0.95rem;\n  color: #1e293b;\n  white-space: nowrap;\n}\n\n.emailInput {\n  height: 48px;\n  outline: none;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  padding: 10px 14px;\n  width: 100%;\n  max-width: 350px;\n  transition: all 0.3s ease;\n  background: #ffffff;\n  color: #0f172a;\n}\n\n.emailInput:hover:not(:disabled) {\n  border-color: #94a3b8;\n}\n\n.emailInput:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);\n  outline: none;\n}\n\n.emailInput:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background-color: #f1f5f9;\n}\n\n/* ========== USER TABS ========== */\n.userTabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.userTab {\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n  padding: 8px 16px;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #1e293b;\n  transition: all 0.3s ease;\n  border: 1px solid transparent;\n}\n\n.userTab:hover {\n  border-color: #94a3b8;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.removeBtn {\n  background: none;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  font-size: 20px;\n  line-height: 1;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  font-weight: 300;\n}\n\n.removeBtn:hover:not(:disabled) {\n  background-color: #fee2e2;\n  color: #ef4444;\n}\n\n.removeBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ========== ROLES SECTION ========== */\n.rolesSection {\n  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px 24px;\n  margin: 10px 0;\n  width: 100%;\n  transition: all 0.3s ease;\n  background-color: white;\n}\n\n.rolesHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.rolesHeader h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.rolesGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n}\n\n.roleCheckbox {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n/* .roleCheckbox:hover {\n  background-color: #f1f5f9;\n} */\n\n.roleCheckbox input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: var(--saveBtn);\n  border-radius: 4px;\n  color: var(--white-color);\n}\n\n.roleCheckbox input[type=\"checkbox\"]:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.roleCheckbox label {\n  font-size: 0.95rem;\n  color: #1e293b;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.noRolesHint {\n  color: #94a3b8;\n  font-size: 0.9rem;\n  font-style: italic;\n  padding: 8px 12px;\n  background: #f8fafc;\n  border-radius: 6px;\n}\n\n.createPermissions {\n  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px 24px;\n  margin: 10px 0;\n  width: 100%;\n  transition: all 0.3s ease;\n}\n\n.createPermissions:hover {\n  border-color: #cbd5e1;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.createPermissionsHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.createPermissionsHeader h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.createPermissionsGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n\n.createPermissionItem {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.createPermissionItem:hover {\n  background-color: #f1f5f9;\n}\n\n.createPermissionItem input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #3b82f6;\n  border-radius: 4px;\n}\n\n.createPermissionItem input[type=\"checkbox\"]:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.createPermissionItem label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 0.95rem;\n  color: #1e293b;\n}\n\n/* ========== INFO ICON ========== */\n.infoIcon {\n  color: #94a3b8;\n  cursor: help;\n  font-size: 16px;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #f1f5f9;\n  transition: all 0.3s ease;\n  font-weight: 600;\n}\n\n.infoIcon:hover {\n  background: #e2e8f0;\n  color: #475569;\n}\n\n.permissionInfo {\n  color: #94a3b8;\n  cursor: help;\n  font-size: 14px;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 4px;\n}\n\n/* ========== TOOLTIP ========== */\n.tooltip {\n  position: absolute;\n  bottom: calc(100% + 10px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: #1e293b;\n  color: #f8fafc;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 0.8rem;\n  width: 220px;\n  z-index: 1000;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n  line-height: 1.5;\n  font-weight: 400;\n}\n\n.tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 6px;\n  border-style: solid;\n  border-color: #1e293b transparent transparent transparent;\n}\n\n/* ========== MULTI-TENANT NOTICE ========== */\n.multiTenantNotice {\n  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);\n  border: 1px solid #fcd34d;\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.08);\n}\n\n.noticeIcon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.multiTenantNotice strong {\n  font-weight: 600;\n  color: #92400e;\n  margin-right: 4px;\n}\n\n/* ========== ERROR MESSAGE ========== */\n.errorMessage {\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  border: 1px solid #fca5a5;\n  border-radius: 12px;\n  padding: 14px 18px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  color: #991b1b;\n  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.06);\n}\n\n.errorIcon {\n  font-size: 20px;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.closeErrorBtn {\n  margin-left: auto;\n  background: none;\n  border: none;\n  color: #991b1b;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0 6px;\n  transition: all 0.2s ease;\n  opacity: 0.7;\n}\n\n.closeErrorBtn:hover {\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n/* ========== PERMISSION NOTE ========== */\n.permissionNote {\n  border: 2px solid #bbd8ff;\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 32px;\n  background: #d9e9ff;\n  transition: all 0.2s ease;\n}\n\n.authServerTitle {\n  color: #1a1614;\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.permissionNote strong {\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.availablePermission {\n  background: var(--gradient-success);\n  color: var(--heading);\n  padding: 2px 10px;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 0.8rem;\n  margin: 0 4px;\n}\n\n/* ========== SUBMIT BUTTON ========== */\n.submitWrapper {\n  margin-top: 24px;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.submitBtn {\n  background: var(--gradient-primary);\n  color: var(--white-color);\n  font-size: 1rem;\n  font-weight: 600;\n  padding: 14px 32px;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 200px;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.submitBtn::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.2),\n    transparent\n  );\n  transition: left 0.5s ease;\n}\n\n.submitBtn:hover:not(:disabled)::before {\n  left: 100%;\n}\n\n.submitBtn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n}\n\n.submitBtn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.submitBtn:disabled {\n  background: var(--cancelBtn);\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n  color: var(--heading);\n}\n\n/* ========== TABLE ========== */\n.tableWrapper {\n  border-radius: 12px;\n  overflow-x: auto;\n  width: 100%;\n  color: #1a1a1a;\n  -webkit-overflow-scrolling: touch;\n  background: var(--white-color);\n  padding: 1.5rem 0;\n  margin-top: 20px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n  border-radius: 12px;\n}\n\n.table {\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n  min-width: 600px;\n}\n\n.table th,\n.table td {\n  padding: 14px 16px;\n  text-align: left;\n  font-size: 0.95rem;\n  font-weight: 400;\n  height: 60px;\n}\n\n.table th {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  color: #1e293b;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid #e2e8f0;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.table td {\n  border-bottom: 1px solid #f1f5f9;\n  background-color: #ffffff;\n  transition: all 0.2s ease;\n}\n\n.table tbody tr {\n  transition: all 0.2s ease;\n}\n\n.table tbody tr:hover td {\n  background-color: #f8fafc;\n}\n\n.table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.table input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #3b82f6;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.table input[type=\"checkbox\"]:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.th {\n  position: relative;\n}\n\n.td {\n  position: relative;\n}\n\n.checkboxWrapper {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* ========== LOADING STATES ========== */\n.loadingText {\n  font-size: 1rem;\n  color: #64748b;\n  text-align: center;\n  padding: 40px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.loadingText::before {\n  content: \"\";\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  border: 3px solid #e2e8f0;\n  border-top: 3px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.noDataText {\n  font-size: 1rem;\n  color: #94a3b8;\n  text-align: center;\n  padding: 40px 20px;\n  font-style: italic;\n}\n\n/* ========== ADMIN ONLY MESSAGE ========== */\n.adminOnlyMessage {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 80px 40px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);\n  max-width: 600px;\n  margin: 60px auto;\n  min-height: 400px;\n}\n\n.adminOnlyIcon {\n  font-size: 72px;\n  margin-bottom: 24px;\n  color: #94a3b8;\n  animation: float 3s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.adminOnlyTitle {\n  color: #1e293b;\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 16px;\n  line-height: 1.3;\n}\n\n.adminOnlyText {\n  color: #64748b;\n  font-size: 16px;\n  line-height: 1.7;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n/* ========== MODAL ========== */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.modal {\n  background: white;\n  border-radius: 16px;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-30px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.modalHeader h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #94a3b8;\n  padding: 4px 8px;\n  line-height: 1;\n  transition: all 0.2s ease;\n  border-radius: 6px;\n}\n\n.closeButton:hover {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.modalContent {\n  padding: 32px 24px;\n  text-align: center;\n}\n\n.modalIcon {\n  font-size: 56px;\n  color: #3b82f6;\n  margin-bottom: 16px;\n}\n\n.modalContent p {\n  margin: 0 0 16px 0;\n  font-size: 1.1rem;\n  color: #475569;\n  line-height: 1.6;\n}\n\n.modalContent .note {\n  font-size: 0.9rem;\n  color: #64748b;\n  margin-top: 16px;\n  padding: 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border-left: 4px solid #3b82f6;\n  text-align: left;\n}\n\n.modalFooter {\n  padding: 20px 24px;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.modalButton {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  color: white;\n  border: none;\n  padding: 10px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.modalButton:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n/* ========== UPCOMING FEATURES ========== */\n.upcomingHeader {\n  position: relative;\n  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%) !important;\n}\n\n.comingSoonBadge {\n  position: absolute;\n  top: 4px;\n  right: 6px;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  font-size: 0.65rem;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n.upcomingCell {\n  position: relative;\n  background: #fffbeb !important;\n  cursor: not-allowed;\n}\n\n.upcomingCell:hover {\n  background: #fef3c7 !important;\n}\n\n.disabledCheckbox {\n  cursor: not-allowed !important;\n  opacity: 0.4;\n  position: relative;\n  z-index: 1;\n}\n\n.upcomingOverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2;\n}\n\n.upcomingText {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  opacity: 0.9;\n  letter-spacing: 0.3px;\n}\n\n/* ========== DISABLED STATES ========== */\ninput:disabled,\nselect:disabled,\nbutton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.authServerDescription {\n  font-size: 0.875rem;\n  color: #5f6368;\n  line-height: 1.5;\n}\n\n.authServerDescription code {\n  background-color: #f1f3f4;\n  padding: 2px 6px;\n  border-radius: 6px;\n  font-family: \"Courier New\", monospace;\n  font-size: 0.813rem;\n  color: #ff32cc;\n}\n/* ========== RESPONSIVE DESIGN ========== */\n@media (min-width: 768px) {\n  .createPermissionsGrid {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  }\n\n  .rolesGrid {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  }\n}\n\n@media (max-width: 767px) {\n  .container {\n    padding: 1rem;\n  }\n\n  .title {\n    font-size: 1.5rem;\n  }\n\n  .headerSection {\n    padding: 0px;\n  }\n\n  .modeSelector {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    width: 100%;\n  }\n\n  .modeDropdown {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .selectSelectorsWrap {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .wrapper {\n    flex-direction: column;\n    width: 100%;\n    gap: 12px;\n  }\n\n  .emailInputWrap,\n  .nameInputWrap {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    gap: 6px;\n  }\n\n  .emailInput {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .createPermissions {\n    padding: 16px;\n  }\n\n  .createPermissionsGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .permissionNote {\n    flex-direction: column;\n    gap: 10px;\n    padding: 16px;\n  }\n\n  .userTabs {\n    max-width: 100%;\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    padding-bottom: 5px;\n  }\n\n  .userTab {\n    white-space: nowrap;\n  }\n\n  .submitBtn {\n    width: 100%;\n    min-width: auto;\n  }\n\n  .submitWrapper {\n    justify-content: stretch;\n  }\n\n  .tableWrapper {\n    padding: 1rem 0.5rem;\n    margin: 15px -1rem;\n    width: calc(100% + 2rem);\n    border-radius: 0;\n  }\n\n  .table {\n    min-width: 500px;\n  }\n\n  .table th,\n  .table td {\n    padding: 10px 12px;\n    font-size: 0.875rem;\n    height: 50px;\n  }\n\n  .inviteSelectorsWrap {\n    align-items: flex-start;\n  }\n\n  .rolesGrid {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .multiTenantNotice {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .errorMessage {\n    flex-wrap: wrap;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .adminOnlyMessage {\n    padding: 40px 20px;\n    margin: 30px 16px;\n    min-height: 300px;\n  }\n\n  .adminOnlyTitle {\n    font-size: 24px;\n  }\n\n  .modal {\n    width: 95%;\n  }\n}\n\n@media (max-width: 480px) {\n  .container {\n    padding: 0rem;\n  }\n\n  .title {\n    font-size: 1.25rem;\n  }\n\n  .emailInput,\n  .modeDropdown {\n    font-size: 16px; /* Prevent zoom on iOS */\n  }\n\n  .createPermissionsHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .createPermissionsHeader h3 {\n    font-size: 0.95rem;\n  }\n\n  .permissionNote {\n    font-size: 0.875rem;\n  }\n\n  .availablePermission {\n    padding: 2px 8px;\n    font-size: 0.75rem;\n  }\n\n  .table {\n    min-width: 400px;\n  }\n\n  .table th,\n  .table td {\n    padding: 8px 10px;\n    font-size: 0.813rem;\n    height: 44px;\n  }\n\n  .table input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n  }\n\n  .rolesGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .submitBtn {\n    font-size: 0.95rem;\n    padding: 12px 20px;\n  }\n\n  .roleCheckbox {\n    padding: 4px 8px;\n  }\n\n  .createPermissionItem {\n    padding: 6px 8px;\n  }\n}\n\n/* ========== PRINT STYLES ========== */\n@media print {\n  .container {\n    box-shadow: none;\n    padding: 0;\n    background: white;\n    min-height: auto;\n  }\n\n  .submitBtn,\n  .removeBtn,\n  .closeErrorBtn {\n    display: none !important;\n  }\n\n  .table {\n    min-width: auto;\n  }\n\n  .headerSection,\n  .rolesSection,\n  .createPermissions {\n    box-shadow: none;\n    border: 1px solid #ddd;\n  }\n\n  .tableWrapper {\n    box-shadow: none;\n    border: 1px solid #ddd;\n  }\n}\n\n/* ========== ACCESSIBILITY ========== */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n@media (prefers-contrast: high) {\n  .errorMessage {\n    border: 2px solid #c00;\n  }\n\n  .multiTenantNotice {\n    border: 2px solid #856404;\n  }\n\n  .table th {\n    border-bottom: 3px solid #000;\n  }\n\n  .submitBtn {\n    border: 2px solid #1d4ed8;\n  }\n}\n/* Minimalist Permission Note */\n.permissionNoteMinimal {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px 24px;\n  margin-bottom: 32px;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.permissionNoteMinimal:hover {\n  border-color: #94a3b8;\n  background: #f1f5f9;\n}\n\n.permissionNoteMinimal .noteIcon {\n  color: #3b82f6;\n  font-size: 20px;\n}\n\n.permissionNoteMinimal .authServerDescription {\n  color: #475569;\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n.permissionNoteMinimal .availablePermission {\n  background: #3b82f6;\n  color: white;\n  padding: 1px 10px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin: 0 3px;\n}\n\n.permissionNoteMinimal .authServerDescription code {\n  background: #e2e8f0;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  color: #7c3aed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hierarchySection": `TenantInvite_hierarchySection__Ok0pO`,
	"hierarchyHeader": `TenantInvite_hierarchyHeader__j5lzG`,
	"hierarchyTitle": `TenantInvite_hierarchyTitle__gSNf8`,
	"hierarchySubtitle": `TenantInvite_hierarchySubtitle__66LQx`,
	"hierarchyControls": `TenantInvite_hierarchyControls__QTHMr`,
	"hierarchySearch": `TenantInvite_hierarchySearch__INI2N`,
	"hierarchyBtn": `TenantInvite_hierarchyBtn__bjKGF`,
	"hierarchyTree": `TenantInvite_hierarchyTree__nnNoc`,
	"hierarchyParent": `TenantInvite_hierarchyParent__fAfJ3`,
	"hierarchyParentIcon": `TenantInvite_hierarchyParentIcon__lDzIq`,
	"hierarchyParentName": `TenantInvite_hierarchyParentName__5U2CB`,
	"hierarchyBadge": `TenantInvite_hierarchyBadge__sUjmh`,
	"hierarchyDepartment": `TenantInvite_hierarchyDepartment__rF720`,
	"hierarchyDepartmentHeader": `TenantInvite_hierarchyDepartmentHeader__FF5QL`,
	"hierarchyCaret": `TenantInvite_hierarchyCaret__K7QuZ`,
	"hierarchyDepartmentIcon": `TenantInvite_hierarchyDepartmentIcon__yUV5w`,
	"hierarchyDepartmentName": `TenantInvite_hierarchyDepartmentName__ODrYa`,
	"hierarchyUserList": `TenantInvite_hierarchyUserList__yMfop`,
	"hierarchyUserItem": `TenantInvite_hierarchyUserItem__UxJR3`,
	"hierarchyUserActive": `TenantInvite_hierarchyUserActive__yzMdJ`,
	"hierarchyUserIcon": `TenantInvite_hierarchyUserIcon__j9p03`,
	"hierarchyUserInfo": `TenantInvite_hierarchyUserInfo__KkeXV`,
	"hierarchyUserName": `TenantInvite_hierarchyUserName__K3KSU`,
	"hierarchyUserEmail": `TenantInvite_hierarchyUserEmail__xTmAR`,
	"hierarchyRoles": `TenantInvite_hierarchyRoles__xWYP2`,
	"hierarchySelectBtn": `TenantInvite_hierarchySelectBtn__QHEZi`,
	"container": `TenantInvite_container__AgJIy`,
	"title": `TenantInvite_title__cIsDT`,
	"headerSection": `TenantInvite_headerSection__zSukl`,
	"inviteSelectorsWrap": `TenantInvite_inviteSelectorsWrap__-Ipht`,
	"selectSelectorsWrap": `TenantInvite_selectSelectorsWrap__EpKTE`,
	"modeSelector": `TenantInvite_modeSelector__yEKbA`,
	"modeDropdown": `TenantInvite_modeDropdown__YdVWY`,
	"wrapper": `TenantInvite_wrapper__thZPy`,
	"emailInputWrap": `TenantInvite_emailInputWrap__rNm9q`,
	"nameInputWrap": `TenantInvite_nameInputWrap__Z60jS`,
	"emailInput": `TenantInvite_emailInput__pz0Rv`,
	"userTabs": `TenantInvite_userTabs__K-184`,
	"userTab": `TenantInvite_userTab__bP7lH`,
	"removeBtn": `TenantInvite_removeBtn__FPK3c`,
	"rolesSection": `TenantInvite_rolesSection__OY6Fo`,
	"rolesHeader": `TenantInvite_rolesHeader__rVISl`,
	"rolesGrid": `TenantInvite_rolesGrid__uQo4O`,
	"roleCheckbox": `TenantInvite_roleCheckbox__blIOe`,
	"noRolesHint": `TenantInvite_noRolesHint__2PNVu`,
	"createPermissions": `TenantInvite_createPermissions__uFx4B`,
	"createPermissionsHeader": `TenantInvite_createPermissionsHeader__b3t5U`,
	"createPermissionsGrid": `TenantInvite_createPermissionsGrid__5ZLpV`,
	"createPermissionItem": `TenantInvite_createPermissionItem__GzkCU`,
	"infoIcon": `TenantInvite_infoIcon__qE-96`,
	"permissionInfo": `TenantInvite_permissionInfo__GmT94`,
	"tooltip": `TenantInvite_tooltip__gLlp+`,
	"multiTenantNotice": `TenantInvite_multiTenantNotice__FChMF`,
	"noticeIcon": `TenantInvite_noticeIcon__RSfKz`,
	"errorMessage": `TenantInvite_errorMessage__4Md7K`,
	"errorIcon": `TenantInvite_errorIcon__M+WDG`,
	"closeErrorBtn": `TenantInvite_closeErrorBtn__gfFG2`,
	"permissionNote": `TenantInvite_permissionNote__qw8z+`,
	"authServerTitle": `TenantInvite_authServerTitle__1SwFt`,
	"availablePermission": `TenantInvite_availablePermission__Pr+n1`,
	"submitWrapper": `TenantInvite_submitWrapper__87mgq`,
	"submitBtn": `TenantInvite_submitBtn__9v9GH`,
	"tableWrapper": `TenantInvite_tableWrapper__-GxpV`,
	"table": `TenantInvite_table__TZSnm`,
	"th": `TenantInvite_th__tBfDk`,
	"td": `TenantInvite_td__cGZBw`,
	"checkboxWrapper": `TenantInvite_checkboxWrapper__FON6O`,
	"loadingText": `TenantInvite_loadingText__5hzIe`,
	"spin": `TenantInvite_spin__ZwKtJ`,
	"noDataText": `TenantInvite_noDataText__ofCoE`,
	"adminOnlyMessage": `TenantInvite_adminOnlyMessage__fs73U`,
	"adminOnlyIcon": `TenantInvite_adminOnlyIcon__ACJqt`,
	"float": `TenantInvite_float__RTVOd`,
	"adminOnlyTitle": `TenantInvite_adminOnlyTitle__uJ4qK`,
	"adminOnlyText": `TenantInvite_adminOnlyText__XP+he`,
	"modalOverlay": `TenantInvite_modalOverlay__w6+im`,
	"fadeIn": `TenantInvite_fadeIn__zROY0`,
	"modal": `TenantInvite_modal__wC7Pc`,
	"modalSlideIn": `TenantInvite_modalSlideIn__RRQG3`,
	"modalHeader": `TenantInvite_modalHeader__f25i6`,
	"closeButton": `TenantInvite_closeButton__OgzFN`,
	"modalContent": `TenantInvite_modalContent__M-P1h`,
	"modalIcon": `TenantInvite_modalIcon__AykcE`,
	"note": `TenantInvite_note__m94kL`,
	"modalFooter": `TenantInvite_modalFooter__YanCd`,
	"modalButton": `TenantInvite_modalButton__1wdTi`,
	"upcomingHeader": `TenantInvite_upcomingHeader__4Aec9`,
	"comingSoonBadge": `TenantInvite_comingSoonBadge__TQuuU`,
	"upcomingCell": `TenantInvite_upcomingCell__xdoQZ`,
	"disabledCheckbox": `TenantInvite_disabledCheckbox__4Qf9R`,
	"upcomingOverlay": `TenantInvite_upcomingOverlay__sCe0z`,
	"upcomingText": `TenantInvite_upcomingText__+IQuF`,
	"authServerDescription": `TenantInvite_authServerDescription__RrtZc`,
	"permissionNoteMinimal": `TenantInvite_permissionNoteMinimal__eW24k`,
	"noteIcon": `TenantInvite_noteIcon__BnCx7`
};
export default ___CSS_LOADER_EXPORT___;
